import React, { useCallback } from "react";
import loadable from "@loadable/component";
import ErrorBoundary from "../../../ErrorBoundary";
import Header from "../../../../containers/Header";
import MainSection from "../../../../containers/MainSection";
import ShopsPage from "../ShopsPage";
import Overlay from "../../../Overlay";
import { useDispatch, useSelector } from "react-redux";
import { createAddTemp } from "../../../../actions/temp";
import ShopsAppHeader from "./ShopsAppHeader";
import {
  useAcceptShopCharges,
  useCreateShopUrlTrigger,
  useHasCapabilities,
} from "../../../../hooks";
import { getPopups } from "../../../../selectors";

const LazyCreateShop = loadable(() => import("../../Creation/CreateShop"));

const ShopsApp = () => {
  const dispatch = useDispatch();
  const popups = useSelector(getPopups);
  const create_shop = useSelector((s: any) => s.temp.create_shop);
  const hasCreateShopCapability = useHasCapabilities("CREATE-SHOP");

  const onCreateShop = useCallback(
    () => dispatch(createAddTemp("create_shop", true)),
    [dispatch],
  );

  const charges = useAcceptShopCharges();
  useCreateShopUrlTrigger({
    canCreateShop: hasCreateShopCapability && charges.acceptShopCharges,
    onCreateShop: onCreateShop,
  });

  return (
    <ErrorBoundary>
      <Header>
        <ShopsAppHeader
          canCreateShop={hasCreateShopCapability && charges.acceptShopCharges}
          onCreateShop={onCreateShop}
        />
      </Header>
      <MainSection popups={popups}>
        <ShopsPage charges={charges} />
      </MainSection>
      <Overlay popups={popups} />
      {create_shop ? <LazyCreateShop /> : null}
    </ErrorBoundary>
  );
};

export default ShopsApp;
